import styled from 'styled-components';

export const StyledTodayStats = styled.div`
    flex-basis: 25%;

    .today-stats-title {
        font-weight: 700;
        font-size: 20px;
        color: #373647;
    }

    .stats {
        display: flex;
        flex-direction: column;
        gap: 50px;
        border-bottom: 1px solid #D8D2FF;
        padding: 5px 0 15px;
        margin: 22px 0 30px;

        .detailed-stats {
            display: flex;
            gap: 16px;
            color: rgba(55, 54, 71, 0.7);
            font-weight: 700;

            .title {
                font-size: 16px;
            }

            .num {
                font-size: 32px;
                line-height: 36px;

                .currency-value {
                    font-size: 28px;

                    .currency-value-amount {
                        margin: 0;
                    }
                }

            }
        }
    }

    .last-actions {
        display: flex;
        flex-direction: column;
        gap: 19px;
        margin-top: 8px;
    }
`